const d소유 = [
  {
    date: "2012-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-04",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-05",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-06",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-07",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-08",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-09",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-10",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-11",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-12",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-01",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-02",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-03",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-04",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-05",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-06",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-07",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-08",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-09",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-10",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-11",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-12",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-01",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-02",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-03",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-04",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-05",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 1,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-06",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 1,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-07",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 1,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 2,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-08",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 1,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 2,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-09",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 1,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 2,
    미아동: 0,
    번동: 0,
    수유동: 1,
    공항동: 0,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-10",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 1,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 2,
    미아동: 0,
    번동: 0,
    수유동: 1,
    공항동: 0,
    등촌동: 2,
    방화동: 3,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-11",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 1,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 2,
    미아동: 0,
    번동: 0,
    수유동: 1,
    공항동: 0,
    등촌동: 3,
    방화동: 3,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-12",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 1,
    약대동: 0,
    여월동: 7,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 2,
    미아동: 0,
    번동: 0,
    수유동: 1,
    공항동: 0,
    등촌동: 3,
    방화동: 3,
    염창동: 0,
    화곡동: 2,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 1,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-01",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 1,
    약대동: 0,
    여월동: 7,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 2,
    미아동: 0,
    번동: 0,
    수유동: 4,
    공항동: 0,
    등촌동: 3,
    방화동: 3,
    염창동: 0,
    화곡동: 9,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 3,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 1,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 1,
    남가좌동: 1,
    연희동: 0,
    홍은동: 1,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 1,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-02",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 1,
    약대동: 0,
    여월동: 7,
    원미동: 4,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 1,
    삼동: 0,
    금오동: 1,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 2,
    미아동: 0,
    번동: 0,
    수유동: 4,
    공항동: 0,
    등촌동: 3,
    방화동: 3,
    염창동: 0,
    화곡동: 9,
    봉천동: 0,
    신림동: 0,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 3,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 1,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 1,
    남가좌동: 1,
    연희동: 0,
    홍은동: 2,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 3,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-03",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 1,
    약대동: 0,
    여월동: 7,
    원미동: 4,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 1,
    죽전동: 0,
    김량장동: 1,
    삼동: 0,
    금오동: 1,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 2,
    미아동: 0,
    번동: 0,
    수유동: 4,
    공항동: 0,
    등촌동: 5,
    방화동: 3,
    염창동: 0,
    화곡동: 17,
    봉천동: 0,
    신림동: 5,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 3,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 1,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 1,
    남가좌동: 2,
    연희동: 0,
    홍은동: 2,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 7,
    신월동: 0,
    신정동: 0,
    갈현동: 2,
    구산동: 3,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-04",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 1,
    약대동: 0,
    여월동: 7,
    원미동: 4,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 1,
    죽전동: 0,
    김량장동: 3,
    삼동: 0,
    금오동: 1,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 2,
    미아동: 0,
    번동: 1,
    수유동: 4,
    공항동: 0,
    등촌동: 5,
    방화동: 3,
    염창동: 0,
    화곡동: 17,
    봉천동: 0,
    신림동: 5,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 3,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 1,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 1,
    남가좌동: 3,
    연희동: 0,
    홍은동: 2,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 10,
    신월동: 0,
    신정동: 0,
    갈현동: 2,
    구산동: 3,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 2,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-05",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 1,
    약대동: 0,
    여월동: 7,
    원미동: 4,
    원종동: 0,
    춘의동: 0,
    세류동: 4,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 1,
    죽전동: 0,
    김량장동: 3,
    삼동: 0,
    금오동: 1,
    녹양동: 0,
    신곡동: 0,
    의정부동: 1,
    호원동: 0,
    천호동: 2,
    미아동: 4,
    번동: 1,
    수유동: 4,
    공항동: 0,
    등촌동: 5,
    방화동: 3,
    염창동: 0,
    화곡동: 22,
    봉천동: 0,
    신림동: 6,
    개봉동: 1,
    고척동: 4,
    신도림동: 0,
    오류동: 1,
    가산동: 0,
    독산동: 5,
    시흥동: 2,
    도봉동: 0,
    창동: 1,
    장안동: 0,
    휘경동: 1,
    대방동: 0,
    사당동: 0,
    상도동: 5,
    서교동: 0,
    성산동: 0,
    신수동: 1,
    남가좌동: 3,
    연희동: 0,
    홍은동: 2,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 12,
    신월동: 1,
    신정동: 3,
    갈현동: 2,
    구산동: 3,
    불광동: 0,
    역촌동: 0,
    응암동: 1,
    숭인동: 0,
    망우동: 2,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-06",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 1,
    사우동: 0,
    호평동: 0,
    괴안동: 3,
    도당동: 0,
    소사본동: 4,
    심곡동: 1,
    심곡본동: 1,
    약대동: 0,
    여월동: 7,
    원미동: 4,
    원종동: 0,
    춘의동: 0,
    세류동: 7,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 1,
    죽전동: 0,
    김량장동: 3,
    삼동: 0,
    금오동: 1,
    녹양동: 0,
    신곡동: 0,
    의정부동: 1,
    호원동: 0,
    천호동: 3,
    미아동: 10,
    번동: 1,
    수유동: 4,
    공항동: 0,
    등촌동: 5,
    방화동: 3,
    염창동: 0,
    화곡동: 28,
    봉천동: 0,
    신림동: 6,
    개봉동: 1,
    고척동: 4,
    신도림동: 0,
    오류동: 1,
    가산동: 1,
    독산동: 6,
    시흥동: 5,
    도봉동: 0,
    창동: 1,
    장안동: 1,
    휘경동: 1,
    대방동: 0,
    사당동: 0,
    상도동: 10,
    서교동: 0,
    성산동: 0,
    신수동: 1,
    남가좌동: 3,
    연희동: 0,
    홍은동: 2,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 20,
    신월동: 1,
    신정동: 3,
    갈현동: 2,
    구산동: 3,
    불광동: 0,
    역촌동: 0,
    응암동: 1,
    숭인동: 0,
    망우동: 2,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-07",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 1,
    사우동: 0,
    호평동: 0,
    괴안동: 3,
    도당동: 0,
    소사본동: 4,
    심곡동: 1,
    심곡본동: 1,
    약대동: 0,
    여월동: 7,
    원미동: 6,
    원종동: 0,
    춘의동: 0,
    세류동: 7,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 2,
    죽전동: 0,
    김량장동: 3,
    삼동: 0,
    금오동: 1,
    녹양동: 0,
    신곡동: 0,
    의정부동: 1,
    호원동: 0,
    천호동: 3,
    미아동: 11,
    번동: 1,
    수유동: 4,
    공항동: 0,
    등촌동: 5,
    방화동: 3,
    염창동: 0,
    화곡동: 30,
    봉천동: 0,
    신림동: 6,
    개봉동: 1,
    고척동: 4,
    신도림동: 5,
    오류동: 1,
    가산동: 2,
    독산동: 6,
    시흥동: 5,
    도봉동: 0,
    창동: 1,
    장안동: 1,
    휘경동: 1,
    대방동: 0,
    사당동: 0,
    상도동: 13,
    서교동: 0,
    성산동: 0,
    신수동: 1,
    남가좌동: 3,
    연희동: 0,
    홍은동: 2,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 23,
    신월동: 1,
    신정동: 3,
    갈현동: 2,
    구산동: 3,
    불광동: 0,
    역촌동: 0,
    응암동: 1,
    숭인동: 0,
    망우동: 2,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-08",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 1,
    사우동: 0,
    호평동: 0,
    괴안동: 3,
    도당동: 0,
    소사본동: 4,
    심곡동: 1,
    심곡본동: 1,
    약대동: 0,
    여월동: 7,
    원미동: 6,
    원종동: 2,
    춘의동: 0,
    세류동: 7,
    인계동: 1,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 2,
    죽전동: 1,
    김량장동: 3,
    삼동: 0,
    금오동: 1,
    녹양동: 0,
    신곡동: 0,
    의정부동: 1,
    호원동: 2,
    천호동: 3,
    미아동: 11,
    번동: 1,
    수유동: 7,
    공항동: 0,
    등촌동: 5,
    방화동: 3,
    염창동: 0,
    화곡동: 35,
    봉천동: 2,
    신림동: 6,
    개봉동: 1,
    고척동: 4,
    신도림동: 5,
    오류동: 1,
    가산동: 4,
    독산동: 12,
    시흥동: 5,
    도봉동: 1,
    창동: 1,
    장안동: 2,
    휘경동: 1,
    대방동: 0,
    사당동: 1,
    상도동: 13,
    서교동: 0,
    성산동: 0,
    신수동: 1,
    남가좌동: 3,
    연희동: 0,
    홍은동: 2,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 23,
    신월동: 1,
    신정동: 4,
    갈현동: 2,
    구산동: 3,
    불광동: 0,
    역촌동: 1,
    응암동: 1,
    숭인동: 0,
    망우동: 2,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-09",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 1,
    사우동: 0,
    호평동: 0,
    괴안동: 3,
    도당동: 0,
    소사본동: 4,
    심곡동: 1,
    심곡본동: 1,
    약대동: 0,
    여월동: 11,
    원미동: 6,
    원종동: 2,
    춘의동: 0,
    세류동: 7,
    인계동: 1,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 2,
    죽전동: 1,
    김량장동: 3,
    삼동: 0,
    금오동: 1,
    녹양동: 0,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 3,
    미아동: 11,
    번동: 1,
    수유동: 11,
    공항동: 1,
    등촌동: 5,
    방화동: 3,
    염창동: 0,
    화곡동: 38,
    봉천동: 2,
    신림동: 6,
    개봉동: 1,
    고척동: 4,
    신도림동: 5,
    오류동: 1,
    가산동: 4,
    독산동: 19,
    시흥동: 5,
    도봉동: 1,
    창동: 1,
    장안동: 2,
    휘경동: 1,
    대방동: 0,
    사당동: 1,
    상도동: 13,
    서교동: 0,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 0,
    홍은동: 2,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 23,
    신월동: 2,
    신정동: 5,
    갈현동: 3,
    구산동: 3,
    불광동: 0,
    역촌동: 1,
    응암동: 1,
    숭인동: 0,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 1,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-10",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 1,
    사우동: 0,
    호평동: 0,
    괴안동: 3,
    도당동: 0,
    소사본동: 4,
    심곡동: 1,
    심곡본동: 1,
    약대동: 0,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 0,
    세류동: 7,
    인계동: 1,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 2,
    죽전동: 1,
    김량장동: 3,
    삼동: 2,
    금오동: 1,
    녹양동: 0,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 3,
    미아동: 11,
    번동: 1,
    수유동: 11,
    공항동: 1,
    등촌동: 5,
    방화동: 3,
    염창동: 0,
    화곡동: 49,
    봉천동: 2,
    신림동: 9,
    개봉동: 1,
    고척동: 4,
    신도림동: 5,
    오류동: 1,
    가산동: 4,
    독산동: 19,
    시흥동: 5,
    도봉동: 1,
    창동: 1,
    장안동: 3,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 13,
    서교동: 1,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 0,
    홍은동: 3,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 23,
    신월동: 3,
    신정동: 5,
    갈현동: 3,
    구산동: 3,
    불광동: 0,
    역촌동: 1,
    응암동: 2,
    숭인동: 0,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 4,
    숭의동: 1,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-11",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 2,
    광명동: 1,
    사우동: 0,
    호평동: 0,
    괴안동: 3,
    도당동: 0,
    소사본동: 4,
    심곡동: 1,
    심곡본동: 1,
    약대동: 0,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 0,
    세류동: 7,
    인계동: 1,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 2,
    죽전동: 1,
    김량장동: 3,
    삼동: 2,
    금오동: 1,
    녹양동: 0,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 3,
    미아동: 11,
    번동: 1,
    수유동: 11,
    공항동: 1,
    등촌동: 6,
    방화동: 3,
    염창동: 0,
    화곡동: 51,
    봉천동: 4,
    신림동: 9,
    개봉동: 1,
    고척동: 4,
    신도림동: 5,
    오류동: 1,
    가산동: 4,
    독산동: 21,
    시흥동: 5,
    도봉동: 1,
    창동: 1,
    장안동: 3,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 14,
    서교동: 1,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 3,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 23,
    신월동: 3,
    신정동: 5,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 2,
    숭인동: 0,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 7,
    숭의동: 2,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-12",
    관산동: 1,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 2,
    광명동: 1,
    사우동: 0,
    호평동: 0,
    괴안동: 3,
    도당동: 0,
    소사본동: 5,
    심곡동: 1,
    심곡본동: 1,
    약대동: 0,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 0,
    세류동: 8,
    인계동: 1,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 3,
    죽전동: 1,
    김량장동: 3,
    삼동: 2,
    금오동: 1,
    녹양동: 0,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 3,
    미아동: 11,
    번동: 1,
    수유동: 11,
    공항동: 1,
    등촌동: 6,
    방화동: 3,
    염창동: 0,
    화곡동: 54,
    봉천동: 4,
    신림동: 11,
    개봉동: 7,
    고척동: 4,
    신도림동: 5,
    오류동: 1,
    가산동: 4,
    독산동: 23,
    시흥동: 5,
    도봉동: 1,
    창동: 1,
    장안동: 3,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 14,
    서교동: 1,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 3,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 23,
    신월동: 3,
    신정동: 5,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 3,
    숭인동: 0,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 7,
    숭의동: 2,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-01",
    관산동: 1,
    성석동: 3,
    식사동: 0,
    풍동: 1,
    가좌동: 2,
    광명동: 1,
    사우동: 0,
    호평동: 0,
    괴안동: 3,
    도당동: 0,
    소사본동: 5,
    심곡동: 3,
    심곡본동: 1,
    약대동: 0,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 0,
    세류동: 8,
    인계동: 1,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 13,
    죽전동: 1,
    김량장동: 3,
    삼동: 2,
    금오동: 1,
    녹양동: 0,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 1,
    등촌동: 8,
    방화동: 3,
    염창동: 0,
    화곡동: 58,
    봉천동: 5,
    신림동: 19,
    개봉동: 17,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 23,
    시흥동: 5,
    도봉동: 1,
    창동: 1,
    장안동: 3,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 14,
    서교동: 1,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 23,
    신월동: 5,
    신정동: 5,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 3,
    숭인동: 0,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 7,
    숭의동: 5,
    주안동: 3,
    부평동: 1,
  },
  {
    date: "2017-02",
    관산동: 1,
    성석동: 7,
    식사동: 0,
    풍동: 1,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 0,
    괴안동: 3,
    도당동: 0,
    소사본동: 5,
    심곡동: 3,
    심곡본동: 1,
    약대동: 0,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 0,
    세류동: 8,
    인계동: 1,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 13,
    죽전동: 1,
    김량장동: 3,
    삼동: 2,
    금오동: 1,
    녹양동: 0,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 1,
    등촌동: 17,
    방화동: 3,
    염창동: 0,
    화곡동: 60,
    봉천동: 5,
    신림동: 21,
    개봉동: 17,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 23,
    시흥동: 5,
    도봉동: 1,
    창동: 1,
    장안동: 3,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 14,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 23,
    신월동: 5,
    신정동: 5,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 3,
    숭인동: 0,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 7,
    숭의동: 10,
    주안동: 3,
    부평동: 1,
  },
  {
    date: "2017-03",
    관산동: 1,
    성석동: 8,
    식사동: 1,
    풍동: 3,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 0,
    괴안동: 3,
    도당동: 0,
    소사본동: 5,
    심곡동: 3,
    심곡본동: 1,
    약대동: 2,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 1,
    세류동: 8,
    인계동: 1,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 13,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 0,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 1,
    등촌동: 18,
    방화동: 3,
    염창동: 3,
    화곡동: 68,
    봉천동: 11,
    신림동: 27,
    개봉동: 23,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 24,
    시흥동: 6,
    도봉동: 1,
    창동: 1,
    장안동: 3,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 16,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 23,
    신월동: 5,
    신정동: 5,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 3,
    숭인동: 0,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 7,
    숭의동: 13,
    주안동: 3,
    부평동: 1,
  },
  {
    date: "2017-04",
    관산동: 1,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 0,
    괴안동: 3,
    도당동: 1,
    소사본동: 5,
    심곡동: 3,
    심곡본동: 1,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 14,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 0,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 1,
    등촌동: 18,
    방화동: 3,
    염창동: 3,
    화곡동: 68,
    봉천동: 16,
    신림동: 28,
    개봉동: 23,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 36,
    시흥동: 6,
    도봉동: 1,
    창동: 1,
    장안동: 3,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 20,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 23,
    신월동: 5,
    신정동: 5,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 3,
    숭인동: 0,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 7,
    숭의동: 13,
    주안동: 4,
    부평동: 1,
  },
  {
    date: "2017-05",
    관산동: 1,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 1,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 3,
    심곡본동: 1,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 0,
    비산동: 0,
    석수동: 1,
    안양동: 14,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 1,
    등촌동: 18,
    방화동: 3,
    염창동: 3,
    화곡동: 69,
    봉천동: 16,
    신림동: 29,
    개봉동: 23,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 36,
    시흥동: 6,
    도봉동: 1,
    창동: 1,
    장안동: 3,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 20,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 23,
    신월동: 7,
    신정동: 5,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 7,
    숭의동: 14,
    주안동: 4,
    부평동: 1,
  },
  {
    date: "2017-06",
    관산동: 1,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 1,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 4,
    심곡본동: 1,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 0,
    비산동: 0,
    석수동: 1,
    안양동: 14,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 1,
    등촌동: 19,
    방화동: 3,
    염창동: 3,
    화곡동: 70,
    봉천동: 16,
    신림동: 29,
    개봉동: 24,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 38,
    시흥동: 6,
    도봉동: 1,
    창동: 1,
    장안동: 3,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 20,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 23,
    신월동: 7,
    신정동: 5,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 0,
    귤현동: 1,
    간석동: 7,
    숭의동: 14,
    주안동: 11,
    부평동: 1,
  },
  {
    date: "2017-07",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 5,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 0,
    비산동: 0,
    석수동: 1,
    안양동: 14,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 1,
    등촌동: 19,
    방화동: 3,
    염창동: 3,
    화곡동: 70,
    봉천동: 16,
    신림동: 30,
    개봉동: 25,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 40,
    시흥동: 22,
    도봉동: 1,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 20,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 23,
    신월동: 7,
    신정동: 5,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 0,
    귤현동: 1,
    간석동: 7,
    숭의동: 14,
    주안동: 11,
    부평동: 1,
  },
  {
    date: "2017-08",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 5,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 0,
    비산동: 0,
    석수동: 1,
    안양동: 14,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 1,
    등촌동: 20,
    방화동: 3,
    염창동: 3,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 25,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 41,
    시흥동: 22,
    도봉동: 1,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 20,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 23,
    신월동: 7,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 0,
    귤현동: 1,
    간석동: 7,
    숭의동: 14,
    주안동: 11,
    부평동: 1,
  },
  {
    date: "2017-09",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 5,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 0,
    석수동: 1,
    안양동: 15,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 1,
    등촌동: 20,
    방화동: 3,
    염창동: 3,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 25,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 41,
    시흥동: 22,
    도봉동: 1,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 20,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 23,
    신월동: 8,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 0,
    귤현동: 1,
    간석동: 7,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2017-10",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 6,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 0,
    석수동: 1,
    안양동: 15,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 2,
    등촌동: 20,
    방화동: 3,
    염창동: 3,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 25,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 41,
    시흥동: 22,
    도봉동: 1,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 20,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 23,
    신월동: 8,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 7,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2017-11",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 6,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 0,
    석수동: 1,
    안양동: 15,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 2,
    등촌동: 20,
    방화동: 3,
    염창동: 3,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 25,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 41,
    시흥동: 27,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 20,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 23,
    신월동: 9,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 7,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2017-12",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 6,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 0,
    석수동: 1,
    안양동: 15,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 2,
    등촌동: 20,
    방화동: 3,
    염창동: 4,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 25,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 41,
    시흥동: 27,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 20,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 9,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 7,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2018-01",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 6,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 0,
    석수동: 1,
    안양동: 15,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 2,
    등촌동: 20,
    방화동: 3,
    염창동: 4,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 25,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 41,
    시흥동: 27,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 20,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 9,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 7,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2018-02",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 6,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 15,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 2,
    등촌동: 20,
    방화동: 3,
    염창동: 4,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 25,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 41,
    시흥동: 27,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 20,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 7,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2018-03",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 6,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 15,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 2,
    등촌동: 20,
    방화동: 3,
    염창동: 4,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 25,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 41,
    시흥동: 27,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 20,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 7,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2018-04",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 6,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 15,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 2,
    등촌동: 20,
    방화동: 3,
    염창동: 4,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 25,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 41,
    시흥동: 27,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 20,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 7,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2018-05",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 2,
    등촌동: 19,
    방화동: 3,
    염창동: 4,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 25,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 41,
    시흥동: 27,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 20,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 7,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2018-06",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 2,
    등촌동: 19,
    방화동: 3,
    염창동: 4,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 41,
    시흥동: 27,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 20,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 7,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2018-07",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 1,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 2,
    등촌동: 19,
    방화동: 3,
    염창동: 4,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 40,
    시흥동: 27,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 21,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 7,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2018-08",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 2,
    등촌동: 19,
    방화동: 3,
    염창동: 4,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 40,
    시흥동: 27,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 21,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2018-09",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 2,
    등촌동: 19,
    방화동: 3,
    염창동: 4,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 40,
    시흥동: 40,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 21,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2018-10",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 2,
    등촌동: 19,
    방화동: 3,
    염창동: 4,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 40,
    시흥동: 40,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 21,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2018-11",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 2,
    등촌동: 19,
    방화동: 3,
    염창동: 4,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 41,
    시흥동: 40,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 21,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2018-12",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 2,
    등촌동: 19,
    방화동: 3,
    염창동: 4,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 41,
    시흥동: 40,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 21,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2019-01",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 2,
    등촌동: 19,
    방화동: 3,
    염창동: 4,
    화곡동: 71,
    봉천동: 16,
    신림동: 30,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 41,
    시흥동: 40,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 21,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2019-02",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 1,
    등촌동: 19,
    방화동: 3,
    염창동: 4,
    화곡동: 70,
    봉천동: 16,
    신림동: 30,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 41,
    시흥동: 40,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 21,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2019-03",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 11,
    번동: 2,
    수유동: 11,
    공항동: 1,
    등촌동: 19,
    방화동: 3,
    염창동: 4,
    화곡동: 70,
    봉천동: 16,
    신림동: 30,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 40,
    시흥동: 40,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 21,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2019-04",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 10,
    번동: 1,
    수유동: 11,
    공항동: 1,
    등촌동: 19,
    방화동: 3,
    염창동: 4,
    화곡동: 70,
    봉천동: 16,
    신림동: 30,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 40,
    시흥동: 40,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 21,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2019-05",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 10,
    번동: 1,
    수유동: 11,
    공항동: 1,
    등촌동: 19,
    방화동: 4,
    염창동: 4,
    화곡동: 70,
    봉천동: 16,
    신림동: 30,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 40,
    시흥동: 40,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 21,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2019-06",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 10,
    번동: 1,
    수유동: 11,
    공항동: 1,
    등촌동: 19,
    방화동: 4,
    염창동: 4,
    화곡동: 70,
    봉천동: 16,
    신림동: 30,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 40,
    시흥동: 40,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 21,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2019-07",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 10,
    번동: 1,
    수유동: 11,
    공항동: 1,
    등촌동: 19,
    방화동: 4,
    염창동: 4,
    화곡동: 70,
    봉천동: 16,
    신림동: 30,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 40,
    시흥동: 40,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 21,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2019-08",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 10,
    번동: 1,
    수유동: 11,
    공항동: 1,
    등촌동: 19,
    방화동: 4,
    염창동: 4,
    화곡동: 70,
    봉천동: 16,
    신림동: 30,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 39,
    시흥동: 40,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 21,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2019-09",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 10,
    번동: 1,
    수유동: 11,
    공항동: 1,
    등촌동: 19,
    방화동: 4,
    염창동: 4,
    화곡동: 70,
    봉천동: 16,
    신림동: 30,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 39,
    시흥동: 40,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 21,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2019-10",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 10,
    번동: 1,
    수유동: 11,
    공항동: 1,
    등촌동: 19,
    방화동: 4,
    염창동: 4,
    화곡동: 70,
    봉천동: 16,
    신림동: 30,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 39,
    시흥동: 40,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 21,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 22,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2019-11",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 10,
    번동: 1,
    수유동: 11,
    공항동: 1,
    등촌동: 19,
    방화동: 4,
    염창동: 4,
    화곡동: 70,
    봉천동: 16,
    신림동: 26,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 39,
    시흥동: 40,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 21,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 21,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2019-12",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 6,
    미아동: 10,
    번동: 1,
    수유동: 11,
    공항동: 1,
    등촌동: 19,
    방화동: 4,
    염창동: 4,
    화곡동: 70,
    봉천동: 16,
    신림동: 26,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 39,
    시흥동: 40,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 18,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 21,
    신월동: 10,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2020-01",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 5,
    미아동: 10,
    번동: 1,
    수유동: 11,
    공항동: 0,
    등촌동: 19,
    방화동: 4,
    염창동: 4,
    화곡동: 70,
    봉천동: 16,
    신림동: 26,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 37,
    시흥동: 40,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 18,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 0,
    목동: 18,
    신월동: 8,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2020-02",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 13,
    원미동: 10,
    원종동: 2,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 16,
    죽전동: 1,
    김량장동: 3,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 5,
    미아동: 10,
    번동: 1,
    수유동: 11,
    공항동: 0,
    등촌동: 20,
    방화동: 3,
    염창동: 4,
    화곡동: 67,
    봉천동: 15,
    신림동: 26,
    개봉동: 26,
    고척동: 6,
    신도림동: 5,
    오류동: 4,
    가산동: 4,
    독산동: 38,
    시흥동: 41,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 18,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 2,
    홍은동: 3,
    서초동: 1,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 1,
    목동: 18,
    신월동: 8,
    신정동: 6,
    갈현동: 3,
    구산동: 3,
    불광동: 3,
    역촌동: 1,
    응암동: 8,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 8,
    숭의동: 14,
    주안동: 12,
    부평동: 1,
  },
  {
    date: "2020-03",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 5,
    원미동: 10,
    원종동: 1,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 14,
    죽전동: 1,
    김량장동: 2,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 5,
    미아동: 7,
    번동: 1,
    수유동: 11,
    공항동: 0,
    등촌동: 15,
    방화동: 3,
    염창동: 3,
    화곡동: 55,
    봉천동: 15,
    신림동: 22,
    개봉동: 12,
    고척동: 2,
    신도림동: 5,
    오류동: 2,
    가산동: 4,
    독산동: 30,
    시흥동: 38,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 14,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 2,
    서초동: 1,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 1,
    목동: 17,
    신월동: 7,
    신정동: 6,
    갈현동: 3,
    구산동: 2,
    불광동: 3,
    역촌동: 0,
    응암동: 7,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 1,
    숭의동: 10,
    주안동: 11,
    부평동: 1,
  },
  {
    date: "2020-04",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 5,
    원미동: 10,
    원종동: 1,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 13,
    죽전동: 1,
    김량장동: 2,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 5,
    미아동: 7,
    번동: 1,
    수유동: 11,
    공항동: 0,
    등촌동: 15,
    방화동: 3,
    염창동: 3,
    화곡동: 55,
    봉천동: 15,
    신림동: 22,
    개봉동: 12,
    고척동: 2,
    신도림동: 5,
    오류동: 2,
    가산동: 4,
    독산동: 30,
    시흥동: 38,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 14,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 2,
    서초동: 1,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 1,
    목동: 17,
    신월동: 7,
    신정동: 6,
    갈현동: 3,
    구산동: 2,
    불광동: 3,
    역촌동: 0,
    응암동: 7,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 1,
    숭의동: 10,
    주안동: 11,
    부평동: 1,
  },
  {
    date: "2020-05",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 5,
    원미동: 10,
    원종동: 1,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 13,
    죽전동: 1,
    김량장동: 2,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 5,
    미아동: 7,
    번동: 1,
    수유동: 11,
    공항동: 0,
    등촌동: 15,
    방화동: 3,
    염창동: 3,
    화곡동: 55,
    봉천동: 15,
    신림동: 22,
    개봉동: 12,
    고척동: 2,
    신도림동: 5,
    오류동: 2,
    가산동: 4,
    독산동: 30,
    시흥동: 38,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 14,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 2,
    서초동: 1,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 1,
    목동: 17,
    신월동: 7,
    신정동: 6,
    갈현동: 3,
    구산동: 2,
    불광동: 3,
    역촌동: 0,
    응암동: 7,
    숭인동: 5,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 1,
    숭의동: 10,
    주안동: 11,
    부평동: 1,
  },
  {
    date: "2020-06",
    관산동: 2,
    성석동: 8,
    식사동: 1,
    풍동: 4,
    가좌동: 2,
    광명동: 2,
    사우동: 1,
    호평동: 6,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 5,
    원미동: 10,
    원종동: 1,
    춘의동: 2,
    세류동: 8,
    인계동: 1,
    관양동: 1,
    비산동: 1,
    석수동: 1,
    안양동: 13,
    죽전동: 1,
    김량장동: 2,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 1,
    호원동: 2,
    천호동: 5,
    미아동: 7,
    번동: 1,
    수유동: 11,
    공항동: 0,
    등촌동: 15,
    방화동: 3,
    염창동: 3,
    화곡동: 54,
    봉천동: 15,
    신림동: 22,
    개봉동: 12,
    고척동: 2,
    신도림동: 5,
    오류동: 2,
    가산동: 4,
    독산동: 30,
    시흥동: 38,
    도봉동: 4,
    창동: 1,
    장안동: 5,
    휘경동: 1,
    대방동: 2,
    사당동: 1,
    상도동: 14,
    서교동: 2,
    성산동: 1,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 2,
    서초동: 1,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 1,
    목동: 17,
    신월동: 7,
    신정동: 6,
    갈현동: 3,
    구산동: 2,
    불광동: 3,
    역촌동: 0,
    응암동: 7,
    숭인동: 4,
    망우동: 2,
    상봉동: 1,
    중화동: 1,
    계산동: 1,
    귤현동: 1,
    간석동: 1,
    숭의동: 10,
    주안동: 11,
    부평동: 1,
  },
  {
    date: "2020-07",
    관산동: 2,
    성석동: 5,
    식사동: 1,
    풍동: 2,
    가좌동: 1,
    광명동: 0,
    사우동: 1,
    호평동: 3,
    괴안동: 3,
    도당동: 2,
    소사본동: 2,
    심곡동: 6,
    심곡본동: 1,
    약대동: 2,
    여월동: 4,
    원미동: 3,
    원종동: 1,
    춘의동: 2,
    세류동: 5,
    인계동: 1,
    관양동: 1,
    비산동: 0,
    석수동: 1,
    안양동: 7,
    죽전동: 1,
    김량장동: 1,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 0,
    호원동: 2,
    천호동: 2,
    미아동: 7,
    번동: 1,
    수유동: 10,
    공항동: 0,
    등촌동: 10,
    방화동: 3,
    염창동: 3,
    화곡동: 38,
    봉천동: 6,
    신림동: 12,
    개봉동: 11,
    고척동: 2,
    신도림동: 4,
    오류동: 2,
    가산동: 2,
    독산동: 25,
    시흥동: 35,
    도봉동: 3,
    창동: 1,
    장안동: 2,
    휘경동: 1,
    대방동: 0,
    사당동: 1,
    상도동: 5,
    서교동: 2,
    성산동: 0,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 1,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 1,
    목동: 11,
    신월동: 4,
    신정동: 5,
    갈현동: 2,
    구산동: 1,
    불광동: 3,
    역촌동: 0,
    응암동: 6,
    숭인동: 2,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 1,
    귤현동: 1,
    간석동: 1,
    숭의동: 6,
    주안동: 7,
    부평동: 0,
  },
  {
    date: "2020-08",
    관산동: 2,
    성석동: 5,
    식사동: 1,
    풍동: 2,
    가좌동: 1,
    광명동: 0,
    사우동: 0,
    호평동: 3,
    괴안동: 3,
    도당동: 2,
    소사본동: 2,
    심곡동: 6,
    심곡본동: 1,
    약대동: 2,
    여월동: 4,
    원미동: 3,
    원종동: 1,
    춘의동: 2,
    세류동: 5,
    인계동: 1,
    관양동: 1,
    비산동: 0,
    석수동: 1,
    안양동: 7,
    죽전동: 1,
    김량장동: 1,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 0,
    호원동: 2,
    천호동: 2,
    미아동: 7,
    번동: 1,
    수유동: 10,
    공항동: 0,
    등촌동: 10,
    방화동: 3,
    염창동: 3,
    화곡동: 38,
    봉천동: 6,
    신림동: 12,
    개봉동: 11,
    고척동: 2,
    신도림동: 4,
    오류동: 2,
    가산동: 2,
    독산동: 25,
    시흥동: 35,
    도봉동: 3,
    창동: 1,
    장안동: 2,
    휘경동: 1,
    대방동: 0,
    사당동: 1,
    상도동: 4,
    서교동: 1,
    성산동: 0,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 1,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 1,
    목동: 11,
    신월동: 4,
    신정동: 5,
    갈현동: 2,
    구산동: 1,
    불광동: 3,
    역촌동: 0,
    응암동: 6,
    숭인동: 2,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 1,
    귤현동: 1,
    간석동: 1,
    숭의동: 6,
    주안동: 7,
    부평동: 0,
  },
  {
    date: "2020-09",
    관산동: 2,
    성석동: 5,
    식사동: 1,
    풍동: 2,
    가좌동: 1,
    광명동: 0,
    사우동: 0,
    호평동: 3,
    괴안동: 3,
    도당동: 2,
    소사본동: 2,
    심곡동: 6,
    심곡본동: 1,
    약대동: 2,
    여월동: 4,
    원미동: 3,
    원종동: 1,
    춘의동: 2,
    세류동: 5,
    인계동: 1,
    관양동: 1,
    비산동: 0,
    석수동: 1,
    안양동: 7,
    죽전동: 1,
    김량장동: 1,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 0,
    호원동: 2,
    천호동: 2,
    미아동: 7,
    번동: 1,
    수유동: 10,
    공항동: 0,
    등촌동: 10,
    방화동: 3,
    염창동: 3,
    화곡동: 37,
    봉천동: 6,
    신림동: 12,
    개봉동: 11,
    고척동: 2,
    신도림동: 4,
    오류동: 2,
    가산동: 2,
    독산동: 25,
    시흥동: 22,
    도봉동: 3,
    창동: 1,
    장안동: 2,
    휘경동: 1,
    대방동: 0,
    사당동: 1,
    상도동: 4,
    서교동: 1,
    성산동: 0,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 0,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 1,
    목동: 11,
    신월동: 4,
    신정동: 5,
    갈현동: 2,
    구산동: 1,
    불광동: 3,
    역촌동: 0,
    응암동: 6,
    숭인동: 2,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 1,
    귤현동: 1,
    간석동: 1,
    숭의동: 6,
    주안동: 7,
    부평동: 0,
  },
  {
    date: "2020-10",
    관산동: 2,
    성석동: 5,
    식사동: 1,
    풍동: 2,
    가좌동: 1,
    광명동: 0,
    사우동: 0,
    호평동: 3,
    괴안동: 3,
    도당동: 2,
    소사본동: 2,
    심곡동: 6,
    심곡본동: 1,
    약대동: 2,
    여월동: 4,
    원미동: 3,
    원종동: 1,
    춘의동: 2,
    세류동: 5,
    인계동: 1,
    관양동: 1,
    비산동: 0,
    석수동: 1,
    안양동: 6,
    죽전동: 1,
    김량장동: 1,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 0,
    호원동: 2,
    천호동: 2,
    미아동: 5,
    번동: 1,
    수유동: 9,
    공항동: 0,
    등촌동: 10,
    방화동: 3,
    염창동: 3,
    화곡동: 37,
    봉천동: 6,
    신림동: 12,
    개봉동: 11,
    고척동: 2,
    신도림동: 4,
    오류동: 2,
    가산동: 2,
    독산동: 25,
    시흥동: 22,
    도봉동: 3,
    창동: 1,
    장안동: 2,
    휘경동: 0,
    대방동: 0,
    사당동: 1,
    상도동: 4,
    서교동: 1,
    성산동: 0,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 0,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 1,
    목동: 11,
    신월동: 4,
    신정동: 5,
    갈현동: 2,
    구산동: 1,
    불광동: 3,
    역촌동: 0,
    응암동: 6,
    숭인동: 2,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 1,
    귤현동: 1,
    간석동: 1,
    숭의동: 6,
    주안동: 7,
    부평동: 0,
  },
  {
    date: "2020-11",
    관산동: 2,
    성석동: 5,
    식사동: 1,
    풍동: 2,
    가좌동: 1,
    광명동: 0,
    사우동: 0,
    호평동: 3,
    괴안동: 3,
    도당동: 2,
    소사본동: 2,
    심곡동: 6,
    심곡본동: 1,
    약대동: 2,
    여월동: 4,
    원미동: 3,
    원종동: 1,
    춘의동: 2,
    세류동: 4,
    인계동: 1,
    관양동: 1,
    비산동: 0,
    석수동: 1,
    안양동: 6,
    죽전동: 1,
    김량장동: 1,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 0,
    호원동: 2,
    천호동: 2,
    미아동: 4,
    번동: 1,
    수유동: 9,
    공항동: 0,
    등촌동: 10,
    방화동: 3,
    염창동: 3,
    화곡동: 37,
    봉천동: 6,
    신림동: 12,
    개봉동: 11,
    고척동: 2,
    신도림동: 4,
    오류동: 2,
    가산동: 2,
    독산동: 25,
    시흥동: 21,
    도봉동: 3,
    창동: 0,
    장안동: 2,
    휘경동: 0,
    대방동: 0,
    사당동: 1,
    상도동: 4,
    서교동: 1,
    성산동: 0,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 0,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 1,
    문정동: 1,
    목동: 11,
    신월동: 4,
    신정동: 5,
    갈현동: 2,
    구산동: 1,
    불광동: 3,
    역촌동: 0,
    응암동: 6,
    숭인동: 2,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 1,
    귤현동: 1,
    간석동: 1,
    숭의동: 6,
    주안동: 6,
    부평동: 0,
  },
  {
    date: "2020-12",
    관산동: 2,
    성석동: 5,
    식사동: 1,
    풍동: 2,
    가좌동: 1,
    광명동: 0,
    사우동: 0,
    호평동: 3,
    괴안동: 3,
    도당동: 2,
    소사본동: 2,
    심곡동: 6,
    심곡본동: 1,
    약대동: 2,
    여월동: 4,
    원미동: 3,
    원종동: 1,
    춘의동: 2,
    세류동: 3,
    인계동: 1,
    관양동: 1,
    비산동: 0,
    석수동: 1,
    안양동: 6,
    죽전동: 1,
    김량장동: 1,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 0,
    호원동: 2,
    천호동: 2,
    미아동: 4,
    번동: 1,
    수유동: 8,
    공항동: 0,
    등촌동: 9,
    방화동: 3,
    염창동: 3,
    화곡동: 36,
    봉천동: 6,
    신림동: 12,
    개봉동: 11,
    고척동: 2,
    신도림동: 4,
    오류동: 2,
    가산동: 2,
    독산동: 25,
    시흥동: 21,
    도봉동: 3,
    창동: 0,
    장안동: 2,
    휘경동: 0,
    대방동: 0,
    사당동: 1,
    상도동: 3,
    서교동: 1,
    성산동: 0,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 0,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 0,
    문정동: 1,
    목동: 11,
    신월동: 4,
    신정동: 5,
    갈현동: 2,
    구산동: 1,
    불광동: 3,
    역촌동: 0,
    응암동: 6,
    숭인동: 1,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 1,
    귤현동: 1,
    간석동: 1,
    숭의동: 6,
    주안동: 6,
    부평동: 0,
  },
  {
    date: "2021-01",
    관산동: 0,
    성석동: 3,
    식사동: 1,
    풍동: 1,
    가좌동: 1,
    광명동: 0,
    사우동: 0,
    호평동: 3,
    괴안동: 3,
    도당동: 2,
    소사본동: 2,
    심곡동: 6,
    심곡본동: 1,
    약대동: 2,
    여월동: 4,
    원미동: 3,
    원종동: 1,
    춘의동: 2,
    세류동: 3,
    인계동: 1,
    관양동: 1,
    비산동: 0,
    석수동: 1,
    안양동: 6,
    죽전동: 1,
    김량장동: 1,
    삼동: 3,
    금오동: 1,
    녹양동: 1,
    신곡동: 2,
    의정부동: 0,
    호원동: 2,
    천호동: 2,
    미아동: 4,
    번동: 1,
    수유동: 8,
    공항동: 0,
    등촌동: 9,
    방화동: 3,
    염창동: 3,
    화곡동: 35,
    봉천동: 6,
    신림동: 12,
    개봉동: 11,
    고척동: 2,
    신도림동: 4,
    오류동: 2,
    가산동: 2,
    독산동: 24,
    시흥동: 19,
    도봉동: 3,
    창동: 0,
    장안동: 2,
    휘경동: 0,
    대방동: 0,
    사당동: 1,
    상도동: 3,
    서교동: 1,
    성산동: 0,
    신수동: 1,
    남가좌동: 3,
    연희동: 1,
    홍은동: 0,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 0,
    문정동: 1,
    목동: 11,
    신월동: 4,
    신정동: 5,
    갈현동: 2,
    구산동: 1,
    불광동: 3,
    역촌동: 0,
    응암동: 6,
    숭인동: 0,
    망우동: 2,
    상봉동: 1,
    중화동: 0,
    계산동: 1,
    귤현동: 1,
    간석동: 1,
    숭의동: 6,
    주안동: 6,
    부평동: 0,
  },
  {
    date: "2021-02",
    관산동: 0,
    성석동: 1,
    식사동: 0,
    풍동: 0,
    가좌동: 1,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 1,
    원미동: 0,
    원종동: 0,
    춘의동: 1,
    세류동: 1,
    인계동: 0,
    관양동: 1,
    비산동: 0,
    석수동: 0,
    안양동: 2,
    죽전동: 0,
    김량장동: 0,
    삼동: 3,
    금오동: 0,
    녹양동: 1,
    신곡동: 2,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 1,
    수유동: 1,
    공항동: 0,
    등촌동: 3,
    방화동: 0,
    염창동: 2,
    화곡동: 7,
    봉천동: 4,
    신림동: 8,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 1,
    가산동: 0,
    독산동: 4,
    시흥동: 2,
    도봉동: 1,
    창동: 0,
    장안동: 2,
    휘경동: 0,
    대방동: 0,
    사당동: 1,
    상도동: 2,
    서교동: 0,
    성산동: 0,
    신수동: 1,
    남가좌동: 2,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 0,
    문정동: 0,
    목동: 2,
    신월동: 1,
    신정동: 2,
    갈현동: 0,
    구산동: 0,
    불광동: 2,
    역촌동: 0,
    응암동: 2,
    숭인동: 0,
    망우동: 1,
    상봉동: 1,
    중화동: 0,
    계산동: 1,
    귤현동: 0,
    간석동: 1,
    숭의동: 2,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2021-03",
    관산동: 0,
    성석동: 1,
    식사동: 0,
    풍동: 0,
    가좌동: 1,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 1,
    원미동: 0,
    원종동: 0,
    춘의동: 1,
    세류동: 1,
    인계동: 0,
    관양동: 1,
    비산동: 0,
    석수동: 0,
    안양동: 2,
    죽전동: 0,
    김량장동: 0,
    삼동: 3,
    금오동: 0,
    녹양동: 1,
    신곡동: 2,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 1,
    수유동: 1,
    공항동: 0,
    등촌동: 3,
    방화동: 0,
    염창동: 2,
    화곡동: 7,
    봉천동: 4,
    신림동: 8,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 1,
    가산동: 0,
    독산동: 4,
    시흥동: 2,
    도봉동: 1,
    창동: 0,
    장안동: 1,
    휘경동: 0,
    대방동: 0,
    사당동: 1,
    상도동: 2,
    서교동: 0,
    성산동: 0,
    신수동: 1,
    남가좌동: 2,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 0,
    문정동: 0,
    목동: 2,
    신월동: 1,
    신정동: 2,
    갈현동: 0,
    구산동: 0,
    불광동: 2,
    역촌동: 0,
    응암동: 2,
    숭인동: 0,
    망우동: 0,
    상봉동: 1,
    중화동: 0,
    계산동: 1,
    귤현동: 0,
    간석동: 1,
    숭의동: 2,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2021-04",
    관산동: 0,
    성석동: 1,
    식사동: 0,
    풍동: 0,
    가좌동: 1,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 1,
    원미동: 0,
    원종동: 0,
    춘의동: 1,
    세류동: 1,
    인계동: 0,
    관양동: 1,
    비산동: 0,
    석수동: 0,
    안양동: 2,
    죽전동: 0,
    김량장동: 0,
    삼동: 3,
    금오동: 0,
    녹양동: 1,
    신곡동: 2,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 1,
    수유동: 1,
    공항동: 0,
    등촌동: 3,
    방화동: 0,
    염창동: 2,
    화곡동: 3,
    봉천동: 4,
    신림동: 8,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 1,
    가산동: 0,
    독산동: 4,
    시흥동: 2,
    도봉동: 1,
    창동: 0,
    장안동: 1,
    휘경동: 0,
    대방동: 0,
    사당동: 1,
    상도동: 2,
    서교동: 0,
    성산동: 0,
    신수동: 1,
    남가좌동: 2,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 0,
    문정동: 0,
    목동: 2,
    신월동: 1,
    신정동: 2,
    갈현동: 0,
    구산동: 0,
    불광동: 2,
    역촌동: 0,
    응암동: 2,
    숭인동: 0,
    망우동: 0,
    상봉동: 1,
    중화동: 0,
    계산동: 1,
    귤현동: 0,
    간석동: 1,
    숭의동: 2,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2021-05",
    관산동: 0,
    성석동: 1,
    식사동: 0,
    풍동: 0,
    가좌동: 1,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 1,
    원미동: 0,
    원종동: 0,
    춘의동: 1,
    세류동: 1,
    인계동: 0,
    관양동: 1,
    비산동: 0,
    석수동: 0,
    안양동: 2,
    죽전동: 0,
    김량장동: 0,
    삼동: 3,
    금오동: 0,
    녹양동: 1,
    신곡동: 2,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 1,
    수유동: 1,
    공항동: 0,
    등촌동: 3,
    방화동: 0,
    염창동: 2,
    화곡동: 3,
    봉천동: 4,
    신림동: 8,
    개봉동: 1,
    고척동: 0,
    신도림동: 0,
    오류동: 1,
    가산동: 0,
    독산동: 4,
    시흥동: 2,
    도봉동: 1,
    창동: 0,
    장안동: 1,
    휘경동: 0,
    대방동: 0,
    사당동: 1,
    상도동: 2,
    서교동: 0,
    성산동: 0,
    신수동: 1,
    남가좌동: 2,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 1,
    석관동: 1,
    하월곡동: 0,
    문정동: 0,
    목동: 2,
    신월동: 1,
    신정동: 2,
    갈현동: 0,
    구산동: 0,
    불광동: 2,
    역촌동: 0,
    응암동: 2,
    숭인동: 0,
    망우동: 0,
    상봉동: 1,
    중화동: 0,
    계산동: 1,
    귤현동: 0,
    간석동: 1,
    숭의동: 2,
    주안동: 0,
    부평동: 0,
  },
];

const d강제경매개시 = [
  {
    date: "2012-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 1,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 1,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 1,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 1,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 1,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 1,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 1,
    호원동: 0,
    천호동: 1,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 1,
    신림동: 2,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 1,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 2,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 1,
    호평동: 1,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 1,
    호원동: 0,
    천호동: 1,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 1,
    신림동: 2,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 1,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 2,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 1,
    호평동: 1,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 1,
    호원동: 0,
    천호동: 1,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 1,
    신림동: 2,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 10,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 2,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 1,
    호평동: 1,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 1,
    호원동: 0,
    천호동: 1,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 1,
    신림동: 2,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 10,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 2,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 1,
    호평동: 1,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 1,
    호원동: 0,
    천호동: 1,
    미아동: 1,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 1,
    신림동: 2,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 10,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 2,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 1,
    호평동: 1,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 1,
    호원동: 0,
    천호동: 1,
    미아동: 1,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 1,
    신림동: 2,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 10,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 2,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 1,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2021-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 1,
    호평동: 1,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 1,
    호원동: 0,
    천호동: 1,
    미아동: 1,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 1,
    신림동: 2,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 10,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 2,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 1,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2021-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 1,
    호평동: 1,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 1,
    호원동: 0,
    천호동: 1,
    미아동: 1,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 2,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 1,
    신림동: 2,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 10,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 2,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 1,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2021-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 1,
    호평동: 1,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 1,
    호원동: 0,
    천호동: 1,
    미아동: 1,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 2,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 1,
    신림동: 2,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 10,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 2,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 1,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2021-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 1,
    호평동: 1,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 1,
    호원동: 0,
    천호동: 1,
    미아동: 1,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 2,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 1,
    신림동: 2,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 10,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 2,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 1,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2021-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 1,
    호평동: 1,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 1,
    호원동: 0,
    천호동: 1,
    미아동: 1,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 2,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 1,
    신림동: 2,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 10,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 2,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 1,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
];

const d압류 = [
  {
    date: "2012-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2012-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2013-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2014-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2015-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2016-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 0,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2017-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 0,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 0,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 1,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 1,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 1,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 1,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 1,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2018-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 1,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 0,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 0,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 1,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 1,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 1,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 1,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 0,
    번동: 0,
    수유동: 0,
    공항동: 1,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 1,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 2,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 1,
    번동: 1,
    수유동: 0,
    공항동: 1,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 1,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 2,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 1,
    번동: 1,
    수유동: 0,
    공항동: 1,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 1,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 2,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 1,
    번동: 1,
    수유동: 0,
    공항동: 1,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 1,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 2,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-07",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 1,
    번동: 1,
    수유동: 0,
    공항동: 1,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 1,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 2,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-08",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 1,
    번동: 1,
    수유동: 0,
    공항동: 1,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 1,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 3,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-09",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 1,
    번동: 1,
    수유동: 0,
    공항동: 1,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 1,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 3,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-10",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 1,
    번동: 1,
    수유동: 0,
    공항동: 1,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 1,
    봉천동: 0,
    신림동: 0,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 3,
    시흥동: 0,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-11",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 1,
    번동: 1,
    수유동: 0,
    공항동: 1,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 1,
    봉천동: 0,
    신림동: 4,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 3,
    시흥동: 1,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 0,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2019-12",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 0,
    미아동: 1,
    번동: 1,
    수유동: 0,
    공항동: 1,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 1,
    봉천동: 0,
    신림동: 4,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 3,
    시흥동: 1,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 3,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 1,
    신월동: 0,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-01",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 1,
    미아동: 1,
    번동: 1,
    수유동: 0,
    공항동: 2,
    등촌동: 1,
    방화동: 0,
    염창동: 0,
    화곡동: 1,
    봉천동: 0,
    신림동: 4,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 5,
    시흥동: 1,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 3,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 4,
    신월동: 2,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-02",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 1,
    미아동: 1,
    번동: 1,
    수유동: 0,
    공항동: 2,
    등촌동: 1,
    방화동: 1,
    염창동: 0,
    화곡동: 4,
    봉천동: 0,
    신림동: 4,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 0,
    가산동: 0,
    독산동: 5,
    시흥동: 1,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 3,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 0,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 4,
    신월동: 2,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 0,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-03",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 0,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 1,
    미아동: 1,
    번동: 1,
    수유동: 0,
    공항동: 2,
    등촌동: 2,
    방화동: 1,
    염창동: 1,
    화곡동: 5,
    봉천동: 0,
    신림동: 4,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 2,
    가산동: 0,
    독산동: 5,
    시흥동: 1,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 3,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 1,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 4,
    신월동: 2,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 1,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-04",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 1,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 1,
    미아동: 1,
    번동: 1,
    수유동: 0,
    공항동: 2,
    등촌동: 2,
    방화동: 1,
    염창동: 1,
    화곡동: 5,
    봉천동: 0,
    신림동: 4,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 2,
    가산동: 0,
    독산동: 5,
    시흥동: 1,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 3,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 1,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 4,
    신월동: 2,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 1,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-05",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 1,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 1,
    미아동: 1,
    번동: 1,
    수유동: 0,
    공항동: 2,
    등촌동: 2,
    방화동: 1,
    염창동: 1,
    화곡동: 5,
    봉천동: 0,
    신림동: 4,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 2,
    가산동: 0,
    독산동: 5,
    시흥동: 1,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 3,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 1,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 4,
    신월동: 2,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 1,
    숭인동: 0,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-06",
    관산동: 0,
    성석동: 0,
    식사동: 0,
    풍동: 0,
    가좌동: 0,
    광명동: 0,
    사우동: 0,
    호평동: 0,
    괴안동: 0,
    도당동: 0,
    소사본동: 0,
    심곡동: 0,
    심곡본동: 0,
    약대동: 0,
    여월동: 0,
    원미동: 0,
    원종동: 0,
    춘의동: 0,
    세류동: 0,
    인계동: 0,
    관양동: 0,
    비산동: 0,
    석수동: 0,
    안양동: 1,
    죽전동: 0,
    김량장동: 0,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 1,
    미아동: 1,
    번동: 1,
    수유동: 0,
    공항동: 2,
    등촌동: 2,
    방화동: 1,
    염창동: 1,
    화곡동: 6,
    봉천동: 0,
    신림동: 4,
    개봉동: 0,
    고척동: 0,
    신도림동: 0,
    오류동: 2,
    가산동: 0,
    독산동: 5,
    시흥동: 1,
    도봉동: 0,
    창동: 0,
    장안동: 0,
    휘경동: 0,
    대방동: 0,
    사당동: 0,
    상도동: 3,
    서교동: 0,
    성산동: 0,
    신수동: 0,
    남가좌동: 0,
    연희동: 1,
    홍은동: 0,
    서초동: 0,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 4,
    신월동: 2,
    신정동: 0,
    갈현동: 0,
    구산동: 0,
    불광동: 0,
    역촌동: 0,
    응암동: 1,
    숭인동: 1,
    망우동: 0,
    상봉동: 0,
    중화동: 0,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 0,
    주안동: 0,
    부평동: 0,
  },
  {
    date: "2020-07",
    관산동: 0,
    성석동: 3,
    식사동: 0,
    풍동: 2,
    가좌동: 1,
    광명동: 2,
    사우동: 0,
    호평동: 2,
    괴안동: 0,
    도당동: 0,
    소사본동: 3,
    심곡동: 2,
    심곡본동: 1,
    약대동: 1,
    여월동: 1,
    원미동: 7,
    원종동: 0,
    춘의동: 0,
    세류동: 3,
    인계동: 0,
    관양동: 0,
    비산동: 1,
    석수동: 0,
    안양동: 7,
    죽전동: 0,
    김량장동: 1,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 3,
    미아동: 1,
    번동: 1,
    수유동: 1,
    공항동: 2,
    등촌동: 7,
    방화동: 1,
    염창동: 1,
    화곡동: 22,
    봉천동: 9,
    신림동: 12,
    개봉동: 1,
    고척동: 0,
    신도림동: 1,
    오류동: 2,
    가산동: 2,
    독산동: 10,
    시흥동: 4,
    도봉동: 1,
    창동: 0,
    장안동: 3,
    휘경동: 0,
    대방동: 2,
    사당동: 0,
    상도동: 12,
    서교동: 0,
    성산동: 1,
    신수동: 0,
    남가좌동: 0,
    연희동: 1,
    홍은동: 1,
    서초동: 1,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 9,
    신월동: 5,
    신정동: 1,
    갈현동: 1,
    구산동: 1,
    불광동: 0,
    역촌동: 0,
    응암동: 2,
    숭인동: 3,
    망우동: 0,
    상봉동: 0,
    중화동: 1,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 4,
    주안동: 4,
    부평동: 1,
  },
  {
    date: "2020-08",
    관산동: 0,
    성석동: 3,
    식사동: 0,
    풍동: 2,
    가좌동: 1,
    광명동: 2,
    사우동: 0,
    호평동: 2,
    괴안동: 0,
    도당동: 0,
    소사본동: 3,
    심곡동: 2,
    심곡본동: 1,
    약대동: 1,
    여월동: 1,
    원미동: 7,
    원종동: 0,
    춘의동: 0,
    세류동: 3,
    인계동: 0,
    관양동: 0,
    비산동: 1,
    석수동: 0,
    안양동: 7,
    죽전동: 0,
    김량장동: 1,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 3,
    미아동: 1,
    번동: 1,
    수유동: 1,
    공항동: 2,
    등촌동: 7,
    방화동: 1,
    염창동: 1,
    화곡동: 22,
    봉천동: 9,
    신림동: 12,
    개봉동: 1,
    고척동: 0,
    신도림동: 1,
    오류동: 2,
    가산동: 2,
    독산동: 10,
    시흥동: 4,
    도봉동: 1,
    창동: 0,
    장안동: 3,
    휘경동: 0,
    대방동: 2,
    사당동: 0,
    상도동: 13,
    서교동: 1,
    성산동: 1,
    신수동: 0,
    남가좌동: 0,
    연희동: 1,
    홍은동: 1,
    서초동: 1,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 9,
    신월동: 5,
    신정동: 1,
    갈현동: 1,
    구산동: 1,
    불광동: 0,
    역촌동: 0,
    응암동: 2,
    숭인동: 3,
    망우동: 0,
    상봉동: 0,
    중화동: 1,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 4,
    주안동: 4,
    부평동: 1,
  },
  {
    date: "2020-09",
    관산동: 0,
    성석동: 3,
    식사동: 0,
    풍동: 2,
    가좌동: 1,
    광명동: 2,
    사우동: 0,
    호평동: 2,
    괴안동: 0,
    도당동: 0,
    소사본동: 3,
    심곡동: 2,
    심곡본동: 1,
    약대동: 1,
    여월동: 1,
    원미동: 7,
    원종동: 0,
    춘의동: 0,
    세류동: 3,
    인계동: 0,
    관양동: 0,
    비산동: 1,
    석수동: 0,
    안양동: 7,
    죽전동: 0,
    김량장동: 1,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 3,
    미아동: 1,
    번동: 1,
    수유동: 1,
    공항동: 2,
    등촌동: 7,
    방화동: 1,
    염창동: 1,
    화곡동: 23,
    봉천동: 9,
    신림동: 12,
    개봉동: 1,
    고척동: 0,
    신도림동: 1,
    오류동: 2,
    가산동: 2,
    독산동: 10,
    시흥동: 8,
    도봉동: 1,
    창동: 0,
    장안동: 3,
    휘경동: 0,
    대방동: 2,
    사당동: 0,
    상도동: 13,
    서교동: 1,
    성산동: 1,
    신수동: 0,
    남가좌동: 0,
    연희동: 1,
    홍은동: 2,
    서초동: 1,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 9,
    신월동: 5,
    신정동: 1,
    갈현동: 1,
    구산동: 1,
    불광동: 0,
    역촌동: 0,
    응암동: 2,
    숭인동: 3,
    망우동: 0,
    상봉동: 0,
    중화동: 1,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 4,
    주안동: 4,
    부평동: 1,
  },
  {
    date: "2020-10",
    관산동: 0,
    성석동: 3,
    식사동: 0,
    풍동: 2,
    가좌동: 1,
    광명동: 2,
    사우동: 0,
    호평동: 2,
    괴안동: 0,
    도당동: 0,
    소사본동: 3,
    심곡동: 2,
    심곡본동: 1,
    약대동: 1,
    여월동: 1,
    원미동: 7,
    원종동: 0,
    춘의동: 0,
    세류동: 3,
    인계동: 0,
    관양동: 0,
    비산동: 1,
    석수동: 0,
    안양동: 8,
    죽전동: 0,
    김량장동: 1,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 3,
    미아동: 3,
    번동: 1,
    수유동: 2,
    공항동: 2,
    등촌동: 7,
    방화동: 1,
    염창동: 1,
    화곡동: 23,
    봉천동: 9,
    신림동: 12,
    개봉동: 1,
    고척동: 0,
    신도림동: 1,
    오류동: 2,
    가산동: 2,
    독산동: 10,
    시흥동: 8,
    도봉동: 1,
    창동: 0,
    장안동: 3,
    휘경동: 1,
    대방동: 2,
    사당동: 0,
    상도동: 13,
    서교동: 1,
    성산동: 1,
    신수동: 0,
    남가좌동: 0,
    연희동: 1,
    홍은동: 2,
    서초동: 1,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 9,
    신월동: 5,
    신정동: 1,
    갈현동: 1,
    구산동: 1,
    불광동: 0,
    역촌동: 0,
    응암동: 2,
    숭인동: 3,
    망우동: 0,
    상봉동: 0,
    중화동: 1,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 4,
    주안동: 4,
    부평동: 1,
  },
  {
    date: "2020-11",
    관산동: 0,
    성석동: 3,
    식사동: 0,
    풍동: 2,
    가좌동: 1,
    광명동: 2,
    사우동: 0,
    호평동: 2,
    괴안동: 0,
    도당동: 0,
    소사본동: 3,
    심곡동: 2,
    심곡본동: 1,
    약대동: 1,
    여월동: 1,
    원미동: 7,
    원종동: 0,
    춘의동: 0,
    세류동: 4,
    인계동: 0,
    관양동: 0,
    비산동: 1,
    석수동: 0,
    안양동: 8,
    죽전동: 0,
    김량장동: 1,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 3,
    미아동: 3,
    번동: 1,
    수유동: 2,
    공항동: 2,
    등촌동: 7,
    방화동: 1,
    염창동: 1,
    화곡동: 23,
    봉천동: 9,
    신림동: 12,
    개봉동: 1,
    고척동: 0,
    신도림동: 1,
    오류동: 2,
    가산동: 2,
    독산동: 10,
    시흥동: 9,
    도봉동: 1,
    창동: 1,
    장안동: 3,
    휘경동: 1,
    대방동: 2,
    사당동: 0,
    상도동: 13,
    서교동: 1,
    성산동: 1,
    신수동: 0,
    남가좌동: 0,
    연희동: 1,
    홍은동: 2,
    서초동: 1,
    마장동: 0,
    석관동: 0,
    하월곡동: 0,
    문정동: 0,
    목동: 9,
    신월동: 5,
    신정동: 1,
    갈현동: 1,
    구산동: 1,
    불광동: 0,
    역촌동: 0,
    응암동: 2,
    숭인동: 3,
    망우동: 0,
    상봉동: 0,
    중화동: 1,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 4,
    주안동: 5,
    부평동: 1,
  },
  {
    date: "2020-12",
    관산동: 0,
    성석동: 3,
    식사동: 0,
    풍동: 2,
    가좌동: 1,
    광명동: 2,
    사우동: 0,
    호평동: 2,
    괴안동: 0,
    도당동: 0,
    소사본동: 3,
    심곡동: 2,
    심곡본동: 1,
    약대동: 1,
    여월동: 1,
    원미동: 7,
    원종동: 0,
    춘의동: 0,
    세류동: 5,
    인계동: 0,
    관양동: 0,
    비산동: 1,
    석수동: 0,
    안양동: 8,
    죽전동: 0,
    김량장동: 1,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 3,
    미아동: 3,
    번동: 1,
    수유동: 3,
    공항동: 2,
    등촌동: 7,
    방화동: 1,
    염창동: 1,
    화곡동: 24,
    봉천동: 9,
    신림동: 12,
    개봉동: 1,
    고척동: 0,
    신도림동: 1,
    오류동: 2,
    가산동: 2,
    독산동: 10,
    시흥동: 9,
    도봉동: 1,
    창동: 1,
    장안동: 3,
    휘경동: 1,
    대방동: 2,
    사당동: 0,
    상도동: 14,
    서교동: 1,
    성산동: 1,
    신수동: 0,
    남가좌동: 0,
    연희동: 1,
    홍은동: 2,
    서초동: 1,
    마장동: 0,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 9,
    신월동: 5,
    신정동: 1,
    갈현동: 1,
    구산동: 1,
    불광동: 0,
    역촌동: 0,
    응암동: 2,
    숭인동: 3,
    망우동: 0,
    상봉동: 0,
    중화동: 1,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 4,
    주안동: 5,
    부평동: 1,
  },
  {
    date: "2021-01",
    관산동: 2,
    성석동: 5,
    식사동: 0,
    풍동: 3,
    가좌동: 1,
    광명동: 2,
    사우동: 0,
    호평동: 2,
    괴안동: 0,
    도당동: 0,
    소사본동: 3,
    심곡동: 2,
    심곡본동: 1,
    약대동: 1,
    여월동: 1,
    원미동: 7,
    원종동: 0,
    춘의동: 0,
    세류동: 5,
    인계동: 0,
    관양동: 0,
    비산동: 1,
    석수동: 0,
    안양동: 8,
    죽전동: 0,
    김량장동: 1,
    삼동: 0,
    금오동: 0,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 0,
    천호동: 3,
    미아동: 3,
    번동: 1,
    수유동: 3,
    공항동: 2,
    등촌동: 7,
    방화동: 1,
    염창동: 1,
    화곡동: 25,
    봉천동: 9,
    신림동: 12,
    개봉동: 1,
    고척동: 0,
    신도림동: 1,
    오류동: 2,
    가산동: 2,
    독산동: 11,
    시흥동: 11,
    도봉동: 1,
    창동: 1,
    장안동: 3,
    휘경동: 1,
    대방동: 2,
    사당동: 0,
    상도동: 14,
    서교동: 1,
    성산동: 1,
    신수동: 0,
    남가좌동: 0,
    연희동: 1,
    홍은동: 2,
    서초동: 1,
    마장동: 0,
    석관동: 0,
    하월곡동: 1,
    문정동: 0,
    목동: 9,
    신월동: 5,
    신정동: 1,
    갈현동: 1,
    구산동: 1,
    불광동: 0,
    역촌동: 0,
    응암동: 2,
    숭인동: 4,
    망우동: 0,
    상봉동: 0,
    중화동: 1,
    계산동: 0,
    귤현동: 0,
    간석동: 0,
    숭의동: 4,
    주안동: 5,
    부평동: 1,
  },
  {
    date: "2021-02",
    관산동: 2,
    성석동: 7,
    식사동: 1,
    풍동: 4,
    가좌동: 1,
    광명동: 2,
    사우동: 0,
    호평동: 5,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 4,
    원미동: 10,
    원종동: 1,
    춘의동: 1,
    세류동: 7,
    인계동: 1,
    관양동: 0,
    비산동: 1,
    석수동: 1,
    안양동: 12,
    죽전동: 1,
    김량장동: 2,
    삼동: 0,
    금오동: 1,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 2,
    천호동: 5,
    미아동: 7,
    번동: 1,
    수유동: 10,
    공항동: 2,
    등촌동: 12,
    방화동: 4,
    염창동: 2,
    화곡동: 53,
    봉천동: 11,
    신림동: 16,
    개봉동: 10,
    고척동: 2,
    신도림동: 5,
    오류동: 3,
    가산동: 4,
    독산동: 31,
    시흥동: 28,
    도봉동: 3,
    창동: 1,
    장안동: 3,
    휘경동: 1,
    대방동: 2,
    사당동: 0,
    상도동: 15,
    서교동: 2,
    성산동: 1,
    신수동: 0,
    남가좌동: 1,
    연희동: 2,
    홍은동: 2,
    서초동: 1,
    마장동: 0,
    석관동: 0,
    하월곡동: 1,
    문정동: 1,
    목동: 18,
    신월동: 8,
    신정동: 4,
    갈현동: 3,
    구산동: 2,
    불광동: 1,
    역촌동: 0,
    응암동: 6,
    숭인동: 4,
    망우동: 1,
    상봉동: 0,
    중화동: 1,
    계산동: 0,
    귤현동: 1,
    간석동: 0,
    숭의동: 8,
    주안동: 11,
    부평동: 1,
  },
  {
    date: "2021-03",
    관산동: 2,
    성석동: 7,
    식사동: 1,
    풍동: 4,
    가좌동: 1,
    광명동: 2,
    사우동: 0,
    호평동: 5,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 4,
    원미동: 10,
    원종동: 1,
    춘의동: 1,
    세류동: 7,
    인계동: 1,
    관양동: 0,
    비산동: 1,
    석수동: 1,
    안양동: 12,
    죽전동: 1,
    김량장동: 2,
    삼동: 0,
    금오동: 1,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 2,
    천호동: 5,
    미아동: 7,
    번동: 1,
    수유동: 10,
    공항동: 2,
    등촌동: 12,
    방화동: 4,
    염창동: 2,
    화곡동: 53,
    봉천동: 11,
    신림동: 16,
    개봉동: 10,
    고척동: 2,
    신도림동: 5,
    오류동: 3,
    가산동: 4,
    독산동: 31,
    시흥동: 28,
    도봉동: 3,
    창동: 1,
    장안동: 4,
    휘경동: 1,
    대방동: 2,
    사당동: 0,
    상도동: 15,
    서교동: 2,
    성산동: 1,
    신수동: 0,
    남가좌동: 1,
    연희동: 2,
    홍은동: 2,
    서초동: 1,
    마장동: 0,
    석관동: 0,
    하월곡동: 1,
    문정동: 1,
    목동: 18,
    신월동: 8,
    신정동: 4,
    갈현동: 3,
    구산동: 2,
    불광동: 1,
    역촌동: 0,
    응암동: 6,
    숭인동: 4,
    망우동: 2,
    상봉동: 0,
    중화동: 1,
    계산동: 0,
    귤현동: 1,
    간석동: 0,
    숭의동: 8,
    주안동: 11,
    부평동: 1,
  },
  {
    date: "2021-04",
    관산동: 2,
    성석동: 7,
    식사동: 1,
    풍동: 4,
    가좌동: 1,
    광명동: 2,
    사우동: 0,
    호평동: 5,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 4,
    원미동: 10,
    원종동: 1,
    춘의동: 1,
    세류동: 7,
    인계동: 1,
    관양동: 0,
    비산동: 1,
    석수동: 1,
    안양동: 12,
    죽전동: 1,
    김량장동: 2,
    삼동: 0,
    금오동: 1,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 2,
    천호동: 5,
    미아동: 7,
    번동: 1,
    수유동: 10,
    공항동: 2,
    등촌동: 12,
    방화동: 4,
    염창동: 2,
    화곡동: 57,
    봉천동: 11,
    신림동: 16,
    개봉동: 10,
    고척동: 2,
    신도림동: 5,
    오류동: 3,
    가산동: 4,
    독산동: 31,
    시흥동: 28,
    도봉동: 3,
    창동: 1,
    장안동: 4,
    휘경동: 1,
    대방동: 2,
    사당동: 0,
    상도동: 15,
    서교동: 2,
    성산동: 1,
    신수동: 0,
    남가좌동: 1,
    연희동: 2,
    홍은동: 2,
    서초동: 1,
    마장동: 0,
    석관동: 0,
    하월곡동: 1,
    문정동: 1,
    목동: 18,
    신월동: 8,
    신정동: 4,
    갈현동: 3,
    구산동: 2,
    불광동: 1,
    역촌동: 0,
    응암동: 6,
    숭인동: 4,
    망우동: 2,
    상봉동: 0,
    중화동: 1,
    계산동: 0,
    귤현동: 1,
    간석동: 0,
    숭의동: 8,
    주안동: 11,
    부평동: 1,
  },
  {
    date: "2021-05",
    관산동: 2,
    성석동: 7,
    식사동: 1,
    풍동: 4,
    가좌동: 1,
    광명동: 2,
    사우동: 0,
    호평동: 5,
    괴안동: 3,
    도당동: 2,
    소사본동: 5,
    심곡동: 8,
    심곡본동: 2,
    약대동: 3,
    여월동: 4,
    원미동: 10,
    원종동: 1,
    춘의동: 1,
    세류동: 7,
    인계동: 1,
    관양동: 0,
    비산동: 1,
    석수동: 1,
    안양동: 12,
    죽전동: 1,
    김량장동: 2,
    삼동: 0,
    금오동: 1,
    녹양동: 0,
    신곡동: 0,
    의정부동: 0,
    호원동: 2,
    천호동: 5,
    미아동: 7,
    번동: 1,
    수유동: 10,
    공항동: 2,
    등촌동: 12,
    방화동: 4,
    염창동: 2,
    화곡동: 57,
    봉천동: 11,
    신림동: 16,
    개봉동: 10,
    고척동: 2,
    신도림동: 5,
    오류동: 3,
    가산동: 4,
    독산동: 31,
    시흥동: 28,
    도봉동: 3,
    창동: 1,
    장안동: 4,
    휘경동: 1,
    대방동: 2,
    사당동: 0,
    상도동: 15,
    서교동: 2,
    성산동: 1,
    신수동: 0,
    남가좌동: 1,
    연희동: 2,
    홍은동: 2,
    서초동: 1,
    마장동: 0,
    석관동: 0,
    하월곡동: 1,
    문정동: 1,
    목동: 18,
    신월동: 8,
    신정동: 4,
    갈현동: 3,
    구산동: 2,
    불광동: 1,
    역촌동: 0,
    응암동: 6,
    숭인동: 4,
    망우동: 2,
    상봉동: 0,
    중화동: 1,
    계산동: 0,
    귤현동: 1,
    간석동: 0,
    숭의동: 8,
    주안동: 11,
    부평동: 1,
  },
];
const area = [
  "관산동",
  "성석동",
  "식사동",
  "풍동",
  "가좌동",
  "광명동",
  "사우동",
  "호평동",
  "괴안동",
  "도당동",
  "소사본동",
  "심곡동",
  "심곡본동",
  "약대동",
  "여월동",
  "원미동",
  "원종동",
  "춘의동",
  "세류동",
  "인계동",
  "관양동",
  "비산동",
  "석수동",
  "안양동",
  "죽전동",
  "김량장동",
  "삼동",
  "금오동",
  "녹양동",
  "신곡동",
  "의정부동",
  "호원동",
  "천호동",
  "미아동",
  "번동",
  "수유동",
  "공항동",
  "등촌동",
  "방화동",
  "염창동",
  "화곡동",
  "봉천동",
  "신림동",
  "개봉동",
  "고척동",
  "신도림동",
  "오류동",
  "가산동",
  "독산동",
  "시흥동",
  "도봉동",
  "창동",
  "장안동",
  "휘경동",
  "대방동",
  "사당동",
  "상도동",
  "서교동",
  "성산동",
  "신수동",
  "남가좌동",
  "연희동",
  "홍은동",
  "서초동",
  "마장동",
  "석관동",
  "하월곡동",
  "문정동",
  "목동",
  "신월동",
  "신정동",
  "갈현동",
  "구산동",
  "불광동",
  "역촌동",
  "응암동",
  "숭인동",
  "망우동",
  "상봉동",
  "중화동",
  "계산동",
  "귤현동",
  "간석동",
  "숭의동",
  "주안동",
  "부평동",
];
export { d소유, d강제경매개시, d압류, area };
